import React, { useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import styles from '../MuiTable/muitable.module.css';
import { DMCALinkStatus } from '../../config/enum';
import { colors, markedDmcaCountLables } from '../../config/constants';
import Pagination from '../Pagination/Pagination';

const WebLinkTable = (props: any) => {
  const { state, markYourPreference, totalRowCount, page, paginateHandler, limit } =
    props;
  const tableElement = document.getElementById('table-row-0');
  useEffect(() => {
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, [state]);

  const markedForDMCA = (item: any, index: number) => {
    return (
      <div key={index} className="border rounded-sm p-1 text-left">
        <div
          data-testid={`WebLinkclick-${index}`}
          onClick={() => markYourPreference && markYourPreference(item, 1)}
          className={`p-1 text-sm space-x-1 border-[#d5d5d6] shadow-sm w-[200px] flex items-center justify-between rounded-sm ${
            !item.isDmcaGenerated && 'cursor-pointer'
          }`}
        >
          <div className="flex items-center space-x-2">
            <div
              className={`h-4 w-4 rounded-sm ${
                item.isDmcaGenerated ? 'bg-[#858586]' : 'bg-red-400'
              }`}
            ></div>
            <div
              className={`text-left ${
                item.isDmcaGenerated ? 'text-[#858586]' : 'text-[#251c1c]'
              }`}
            >
              {markedDmcaCountLables.markedDMCA}
            </div>
          </div>
          <div
            className={`bg-white border w-6 h-6 flex items-center justify-center rounded-full border-[#858586]`}
          >
            {item.weblinkPreference === DMCALinkStatus.IsMarkedDmca && (
              <i className="fa-solid fa-circle-check text-[green] text-2xl"></i>
            )}
          </div>
        </div>

        <div
          onClick={() => markYourPreference(item, 2)}
          className={`mt-1 p-1 text-sm space-x-1 shadow-sm w-[200px] flex items-center justify-between rounded-sm ${
            !item.isDmcaGenerated && 'cursor-pointer'
          }`}
        >
          <div className="flex items-center space-x-2">
            <div
              className={`h-4 w-4 rounded-sm ${
                item.isDmcaGenerated ? 'bg-[#858586]' : 'bg-yellow-400'
              }`}
            ></div>
            <div
              className={` text-left ${
                item.isDmcaGenerated ? 'text-[#858586]' : 'text-[#251c1c]'
              }`}
            >
              {markedDmcaCountLables.markedRevisit}
            </div>
          </div>
          <div
            className={`bg-white border w-6 h-6 flex items-center justify-center rounded-full border-[#858586]`}
          >
            {item.weblinkPreference === DMCALinkStatus.IsMarkedRevisit && (
              <i className="fa-solid fa-circle-check text-[green] text-2xl"></i>
            )}
          </div>
        </div>
        <div
          onClick={() => markYourPreference(item, 3)}
          className={` mt-1 p-1 text-sm space-x-1 shadow-sm w-[200px] flex items-center justify-between rounded-sm  ${
            !item.isDmcaGenerated && 'cursor-pointer'
          }`}
        >
          <div className="flex items-center space-x-2">
            <div
              className={`h-4 w-4 rounded-sm ${
                item.isDmcaGenerated ? 'bg-[#858586]' : 'bg-green-400'
              }`}
            ></div>
            <div
              className={`${
                item.isDmcaGenerated ? 'text-[#858586]' : 'text-[#251c1c]'
              }`}
            >
              {markedDmcaCountLables.ignored}
            </div>
          </div>
          <div
            className={`bg-white border w-6 h-6 flex items-center justify-center rounded-full border-[#858586]`}
          >
            {item.weblinkPreference === DMCALinkStatus.IsMarkedIgnore && (
              <i className="fa-solid fa-circle-check text-[green] text-2xl"></i>
            )}
          </div>
        </div>
      </div>
    );
  };

  const highlightContent = (content: any) => {
    const contentLengthCheck =
      content.length < 550 ? content : content.substring(0, 550);
    const parts = contentLengthCheck.split('###');
    // Initialize an array to store the elements
    const elements: any = [];
    parts.forEach((part: string, index: number) => {
      if (index % 2 === 0) {
        // This is plain text, add it as is
        elements.push(part);
      } else {
        // This is a word to highlight, wrap it in a span
        elements.push(<span className="bg-[#fcfc3a]">{part.toString()}</span>);
      }
    });
    return (
      <div>
        {elements}
        {content.length > 550 && <div>...</div>}
      </div>
    );
  };
  return (
    <div data-testid="WebLink-wrapper">
      {state !== null && (
        <>
          {state.length > 0 ? (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table" align="left">
                  <TableHead classes={{ root: styles.tableHead }}>
                    <TableRow>
                      <TableCell
                        style={{ width: '90%', fontSize: '14px' }}
                        classes={{ root: styles.tableHeadCell }}
                      >
                        WebLinks
                      </TableCell>
                      <TableCell
                        style={{
                          width: '10%',
                          paddingLeft: '50px',
                          fontSize: '14px',
                        }}
                        classes={{ root: styles.tableHeadCell }}
                      >
                        Mark Preference
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {state.map((item: any, index: number) => {
                      return (
                        <TableRow key={index} id={`table-row-${index}`}>
                          <TableCell
                            className="w-[70%]"
                            classes={{ root: styles.tablebody }}
                          >
                            <a
                              href={item.weblinkUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-[blue]"
                            >
                              {item.weblinkUrl}
                            </a>

                            <div>{highlightContent(item.matchContent)}</div>
                          </TableCell>
                          <TableCell
                            className="w-[20%]"
                            classes={{ root: styles.tablebody }}
                          >
                            {markedForDMCA(item, index)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              {state?.length > 0 && (
                <div className="m-4">
                  <Pagination
                    page={page}
                    limit={limit}
                    paginateHandler={paginateHandler}
                    totalRowCount={totalRowCount}
                  />
                </div>
              )}
            </Paper>
          ) : (
            <div
              className={`p-2 ${colors.primaryText} border w-full rounded-md text-[#1b2e49] shadow-sm`}
            >
              Sorry! No weblink found.
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WebLinkTable;
